import { useState } from "react";
import "./circlePicker.scss";
import { ReactComponent as CheckIcon } from "../../../../assets/checkIcon.svg";
import { MediaType } from "../../../enums/mediaTypes";
import { ThemeColorModel } from "../../../../modules/createCampaign/models/themeModel";
import { Color } from "../../../style/colors";
import { ReactComponent as InfoIcon } from "../../../../assets/infoIcon.svg";
import { ReactComponent as ExitIcon } from "../../../../assets/exitIcon.svg";
import Tooltip from "../../tooltip/tooltip";

export default function CirclePicker(props: {
  title?: string;
  value?: ThemeColorModel;
  option?: ThemeColorModel[];
  infoText?: string;
  editable?: boolean;
  onChange?: (e: ThemeColorModel) => void;
  onDelete?: (e: ThemeColorModel) => void;
}) {
  const [selectedCircle, setSelectedCircle] = useState(props.value);
  const [isEdited, setIsEdited] = useState(false);
  return (
    <div className="circle-picker-contianer">
      <div className="title">
        {props.title}
        {props.infoText && (
          <Tooltip text={props.infoText}>
            <InfoIcon width={15} height={15} />
          </Tooltip>
        )}
        <div style={{ flex: 1 }} />
        {props.editable && (
          <span
            className="circle-edit-button"
            onClick={() => setIsEdited(!isEdited)}
          >
            {!isEdited ? "Edit" : "Done"}
          </span>
        )}
      </div>
      <div className="circle-container">
        {props.option?.map((e, i) => (
          <div
            key={i}
            className={`circle ${
              selectedCircle?.value == e.value && "circle-selected"
            }`}
            onClick={() => {
              props.onChange?.(e);
              setSelectedCircle(e);
            }}
          >
            <div
              className="circle-background"
              style={{
                backgroundColor:
                  e.type == MediaType.COLOR ? e.value : undefined,
                backgroundImage:
                  e.type == MediaType.IMAGE ? `url(${e.value})` : undefined,
              }}
            >
              {e.type == MediaType.MP4 ? (
                <video
                  className="circle-background-video"
                  autoPlay
                  loop
                  muted
                  poster={e.value}
                >
                  <source src={e.value} type="video/mp4" />
                </video>
              ) : (
                <></>
              )}
            </div>
            {selectedCircle?.value == e.value && (
              <div className="check-icon-container">
                <CheckIcon
                  height={20}
                  width={20}
                  stroke={Color().primaryColor}
                />
              </div>
            )}
            {isEdited && e.type != MediaType.COLOR && (
              <div
                className="circle-delete-icon"
                onClick={() => props.onDelete?.(e)}
              >
                <ExitIcon height={10} stroke={"white"} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
